import { validateTel } from '@/utils/validate'
import { BIZ_TYPES } from './const'
import { limitFloat, limitInteger, trimZero, limitIdCard } from './limit'
import { showTip } from './tip'
import { Message } from '@qs/ui'
/**
 * 更新数据
 * @param {*} element 元素
 * @param {*} val 新值
 */
const updateVal = (element, val) => {
  if (element.value === val) return
  // eslint-disable-next-line no-param-reassign
  element.value = val
  element.dispatchEvent(new CustomEvent('input'))
}

// 核心处理逻辑
export const INPUT_HANDLER = {
  // 整数：通过binding的值限制长度，默认18位
  [BIZ_TYPES.Integer]: {
    keyup: (e, binding) => {
      const element = e.target
      const oldValue = element.value
      const newValue = limitInteger(oldValue, binding.value)
      if (newValue !== oldValue) {
        showTip(element, binding.value === -1 ? '只支持正整数' : `最多输入${binding.value || 18}位整数`)
      }
      updateVal(element, newValue)
    },
    blur(e, binding) {
      const { noZero } = binding.modifiers
      const element = e.target
      const oldValue = element.value
      let newValue = limitInteger(oldValue, binding.value)
      if (newValue !== oldValue) {
        showTip(element, binding.value === -1 ? '只支持正整数' : `最多输入${binding.value || 18}位整数`)
      }
      // 是否需要去除首尾的0，默认去除
      const { noTrim } = binding.modifiers
      if (!noTrim) newValue = trimZero(newValue, noZero)
      updateVal(element, newValue)
    },
  },
  // 身份证件号：通过binding的值限制长度，默认18位
  [BIZ_TYPES.IdCard]: {
    blur(e, binding) {
      const element = e.target
      const oldValue = element.value
      const newValue = limitIdCard(oldValue, binding.value)
      if (newValue !== oldValue) {
        showTip(element, '请输入正确的身份证号')
      }

      updateVal(element, newValue)
    },
  },
  // 小数：通过binding的值限制整数长度，默认整数8位，小数2位
  [BIZ_TYPES.Float]: {
    keyup: (e, binding) => {
      const element = e.target
      const oldValue = element.value
      const newValue = limitFloat(oldValue, binding.value)
      if (newValue !== oldValue) {
        showTip(element, binding.value === -1 ? '只支持整数，及2位小数' : `最多输入${binding.value || 8}位整数，2位小数`)
      }
      updateVal(element, newValue)
    },
    blur(e, binding) {
      const { noZero } = binding.modifiers
      const element = e.target
      const oldValue = element.value
      const newValue = limitFloat(oldValue, binding.value)
      if (newValue !== oldValue) {
        showTip(element, binding.value === -1 ? '只支持整数，及2位小数' : `最多输入${binding.value || 8}位整数，2位小数`)
      }
      updateVal(element, trimZero(newValue, noZero))
    },
  },
  // 手机号：11位，数字（正则）
  [BIZ_TYPES.Phone]: {
    keyup: (e) => {
      const element = e.target
      const oldValue = element.value
      const newValue = limitInteger(oldValue, 11)
      if (newValue !== oldValue) {
        showTip(element, '手机号格式不正确')
      }
      updateVal(element, newValue)
    },
    blur(e) {
      const element = e.target
      if (!validateTel(element.value)) {
        showTip(element, '手机号格式不正确')
        updateVal(element, '')
      }
    },
  },
  // 金额：8位，支持8位整数或8位整数+小数点后2位
  [BIZ_TYPES.Money]: {
    keyup: (e, binding) => {
      const { isHideErr = true } = binding.value || {}
      const element = e.target
      const oldValue = element.value
      const newValue = limitFloat(oldValue)
      if (newValue !== oldValue && !isHideErr) {
        Message({
          type: 'error',
          message: '请输入数字，整数位不能超过 8 位,小数位不能超过 2 位',
        })
      }
      updateVal(element, newValue)
    },
    blur(e, binding) {
      const { isHideErr = true } = binding.value || {}
      const { noZero } = binding.modifiers
      const element = e.target
      const oldValue = element.value
      const newValue = limitFloat(oldValue)
      if (newValue !== oldValue && !isHideErr) {
        Message({
          type: 'error',
          message: '请输入数字，整数位不能超过 8 位,小数位不能超过 2 位',
        })
      }
      updateVal(element, trimZero(newValue, noZero))
    },
  },
  // 百分比：数字，支持小数，最小值0，不限制最大值
  [BIZ_TYPES.Percent]: {
    keyup: (e, binding) => {
      const { integer, max100 } = binding.modifiers
      const element = e.target
      const oldValue = element.value
      if (max100 && /^[0-9]+(\.[0-9]{1,2})?$/.test(oldValue)) {
        const newValue = String(Math.min(oldValue, 100))
        if (newValue !== oldValue) {
          showTip(element, '限制最大100')
        }
        return updateVal(element, newValue)
      }
      if (integer) {
        const newValue = limitInteger(oldValue, 8)
        if (newValue !== oldValue) {
          showTip(element, max100 ? '限制最大100' : '最多输入8位整数')
        }
        return updateVal(element, newValue)
      }
      const newValue = limitFloat(oldValue)
      if (newValue !== oldValue) {
        showTip(element, max100 ? '限制最大100，2位小数' : '最多输入8位整数，2位小数')
      }
      updateVal(element, newValue)
    },
    blur(e, binding) {
      const element = e.target
      const { integer, max100, noZero } = binding.modifiers
      const oldValue = element.value
      if (max100 && /^[0-9]+(\.[0-9]{1,2})?$/.test(oldValue)) {
        const newValue = String(Math.min(oldValue, 100))
        if (newValue !== oldValue) {
          showTip(element, '限制最大100')
        }
        return updateVal(element, newValue)
      }
      if (integer) {
        const newValue = limitInteger(oldValue, 8)
        if (newValue !== oldValue) {
          showTip(element, max100 ? '限制最大100' : '最多输入8位整数')
        }
        return updateVal(element, trimZero(newValue, noZero))
      }
      const newValue = limitFloat(oldValue)
      if (newValue !== oldValue) {
        showTip(element, max100 ? '限制最大100，2位小数' : '最多输入8位整数，2位小数')
      }
      updateVal(element, trimZero(newValue, noZero))
    },
  },
  // 公里：数字，支持6位整数(网约车60万公里强制报废)
  [BIZ_TYPES.Km]: {
    keyup: (e) => {
      const element = e.target
      const oldValue = element.value
      const newValue = limitInteger(oldValue, 6)
      if (newValue !== oldValue) {
        showTip(element, '最多输入6位整数')
      }
      updateVal(element, newValue)
    },
    blur(e, binding) {
      const { noZero } = binding.modifiers
      const element = e.target
      const oldValue = element.value
      const newValue = limitInteger(oldValue, 6)
      if (newValue !== oldValue) {
        showTip(element, '最多输入6位整数')
      }
      updateVal(element, trimZero(newValue, noZero))
    },
  },
}
